import { ConfirmDialog } from '@agilelab/plugin-wb-platform';
import { useEffect } from 'react';
import { useAssignmentsContext } from './AssignmentsContext';

export const RemoveConfirmDialog = () => {
  const {
    setOpenConfirmDialog,
    openConfirmDialog,
    selectedRemoveItems,
    setSelectedRemoveItems,
    selectedRow,
    removeAssignments,
  } = useAssignmentsContext();

  useEffect(() => {
    if (selectedRow !== undefined && openConfirmDialog)
      setSelectedRemoveItems([selectedRow]);
  }, [selectedRow, setSelectedRemoveItems, openConfirmDialog]);

  return (
    <ConfirmDialog
      title="Remove assignment"
      description={`Are you sure you want to remove ${
        selectedRemoveItems.length
      } ${
        selectedRemoveItems.length === 1 ? 'assignment' : 'assignments'
      } from this role?`}
      onConfirm={() => {
        removeAssignments(selectedRemoveItems.map(i => i.userOrGroup.urn));
        setOpenConfirmDialog(false);
        setSelectedRemoveItems([]);
      }}
      open={openConfirmDialog}
      onClose={() => {
        setOpenConfirmDialog(false);
        setSelectedRemoveItems([]);
      }}
      confirmButtonText="Remove"
    />
  );
};
